import { Box, CircularProgress, Divider } from '@mui/material';
import React from 'react';
import RemoveItem from '../../assets/images/remove-item.png';
import { styled } from 'styled-components';
import CustomButton from '../CustomButton/CustomButton';
import { SecurityIcon } from '../Icons';

const StyledText = styled.div`
	width: 100%;
	color: var(--default-text-color);
	text-align: center;
	font-size: 15px;
	font-weight: 400;
	line-height: 21px;
	letter-spacing: 0.28px;
`;

const StyledHeading = styled.h3`
	color: var(--Black, #1a1a1a);
	font-size: 18px;
	font-weight: 600;
	line-height: 24px;
	letter-spacing: 0.28px;
`;
type Props = {
	handleClose: () => void;
	handleConfirm: () => void;
	title?: string;
	item?: { count: number; name: string };
	loading: boolean;
	content?: any;
	icon?: any;
	btnView?: '1' | '2';
};
const SecurityAlertModal: React.FC<Props> = ({
	item,
	handleClose,
	handleConfirm,
	title = 'Security Alert',
	loading,
	content = 'In response to ongoing security enhancements, a new set of credentials will be generated for your account. It is crucial to note that your previous credentials have been deprecated for security reasons.',
	icon = (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				width: '48px',
				height: '48px',
				background: '#FCDFE6',
				borderRadius: '50%',
			}}
		>
			<SecurityIcon />
		</div>
	),
	btnView = '2',
}) => {
	return (
		<form>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				padding="25px"
				gap="15px"
			>
				{icon}
				<StyledHeading>{title}</StyledHeading>
				<StyledText>{content}</StyledText>
			</Box>
			<Divider style={{ width: '100%' }} />
			{btnView === '1' ? (
				<Box display="flex" justifyContent="center" gap="10px" p={2}>
					<CustomButton
						title="No"
						handleClick={handleClose}
						styles={{
							width: '103px',
							height: '36px',
							borderRadius: '4px',
							background: 'var(--btn-color-grey)',
							color: 'var(--default-text-color)',
							':hover': {
								background: 'var(--btn-hover-color) !important',
							},
						}}
					/>
					<CustomButton
						title={
							loading ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Yes'
							)
						}
						disabled={loading}
						handleClick={handleConfirm}
						styles={{
							width: '104px',
							height: '36px',
							borderRadius: '4px',
							background: 'var(--color-primary)',
							color: 'var(--default-text-color)',
						}}
					/>
				</Box>
			) : (
				<Box display="flex" justifyContent="center" gap="10px" p={2}>
					<CustomButton
						title="Cancel"
						handleClick={handleClose}
						styles={{
							width: '154px',
							height: '36px',
							borderRadius: '4px',
							background: 'var(--btn-color-grey)',
							color: 'var(--default-text-color)',
							':hover': {
								background: 'var(--btn-hover-color) !important',
							},
						}}
					/>
					<CustomButton
						title={
							loading ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Continue Anyway'
							)
						}
						disabled={loading}
						handleClick={handleConfirm}
						styles={{
							width: '205px',
							height: '36px',
							borderRadius: '4px',
							background: 'var(--color-primary)',
							color: 'var(--default-text-color)',
						}}
					/>
				</Box>
			)}
		</form>
	);
};

export default SecurityAlertModal;
